module.exports = __webpack_public_path__ + "img/xkt.938248e8.png";